 import dateYearMonth from './dateYearMonth'
 import checkRadio from './checkRadio';
 import reservationDate from './reservationDate';
 import address from './address';
 import divider from './divider';

 import confirm from './confirm';
 export default {
   init(Vue, options = {}) {
     Vue.confirm = Vue.prototype.confirm$ = confirm;

     Vue.use(dateYearMonth);
     Vue.use(checkRadio);
     Vue.use(reservationDate);
     Vue.use(address);
     Vue.use(divider);
   }
 }



// WEBPACK FOOTER //
// ./src/_components/index.js